var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector2Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 33.75V37.125H14.4889L3.375 48.2389L5.76113 50.625L16.875 39.5111V47.25H20.25V33.75H6.75Z",
    fill: "#00AFEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.625 6.75H38.8125V10.125H44.8639L32.0625 22.9264L24.8181 15.6819C24.5016 15.3656 24.0725 15.1879 23.625 15.1879C23.1775 15.1879 22.7484 15.3656 22.4319 15.6819L13.5 24.6139L15.8861 27L23.625 19.2611L30.8694 26.5056C31.1859 26.8219 31.615 26.9996 32.0625 26.9996C32.51 26.9996 32.9391 26.8219 33.2556 26.5056L47.25 12.5111V18.5625H50.625V6.75Z",
    fill: "#00AFEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 47.25H50.625V50.625H27V47.25Z",
    fill: "#00AFEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 3.375H6.75V27H3.375V3.375Z",
    fill: "#00AFEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2Blue);
export default __webpack_public_path__ + "static/media/vector-2-blue.2f2791b62df22064d8655168b4d14255.svg";
export { ForwardRef as ReactComponent };